import { render } from "./SignLayout.vue?vue&type=template&id=321f9b1e"
import script from "./SignLayout.vue?vue&type=script&lang=js"
export * from "./SignLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\jm.loc\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__